import { callUnaryMethod, useTransport } from "@connectrpc/connect-query";
import { useQuery } from "@tanstack/react-query";
import { ReservationService } from "@viajero/proto/guest/v1";

/**
 * ReservationService.GetReservationContext を connect-query でラップするフック。
 *
 * 店舗詳細画面 (/{caseToken}/{shopId}) の予約希望日時表示 (§6.2) と、
 * コース詳細画面 (/{caseToken}/{shopId}/{productId}) の利用日時デフォルト値 (§6.3) で使う。
 * 後者は feature 間 import を避けるため app 層 (CourseDetailPage) から呼ぶ (ADR-009)。
 * リクエストパラメータはなく、`x-case-token` ヘッダ (lib/client.ts の caseTokenInterceptor)
 * から解決した案件の予約希望日時をそのまま返す。
 *
 * レスポンスはリクエストが空メッセージのため、connect-query 標準の `useQuery` を使うと
 * queryKey がリクエスト内容だけで決まり caseToken を区別できない
 * (別案件へ遷移しても staleTime の間は前の案件の予約希望日時がキャッシュから表示され得る)。
 * そのため queryKey に caseToken を含め、案件ごとにキャッシュを分離する。
 */
export function useGetReservationContext(caseToken: string, enabled: boolean) {
  const transport = useTransport();
  return useQuery({
    queryKey: ["reservationContext", caseToken],
    queryFn: ({ signal }) =>
      callUnaryMethod(transport, ReservationService.method.getReservationContext, {}, { signal }),
    enabled,
  });
}
